import styled from 'styled-components';
import media from '../../styled/media';

export const MobileOnly = styled.div`
  ${media.tablet`
    display: none;
  `}
`;

export const DesktopOnly = styled.div`
  display: none;
  ${media.tablet`
    display: block;
  `}
`;

export const H2 = styled.h2`
  margin: 0 0 32px;
  font-size: 26px;
  line-height: 32px;
  ${media.tablet`
    font-size: 40px;
    line-height: 48px;
  `}
  span {
    color: #cb2027;
  }
`;

export const Text = styled.p`
  margin: 16px 0;
  font-size: 16px;
  line-height: 27px;
  ${media.tablet`
    margin: 18px 0;
    font-size: 18px;
  `}
`;

export const Section = styled.div<{ backgroundFill?: boolean }>`
  padding: 40px 0;
  background: ${({ backgroundFill }) => (backgroundFill ? '#EBEBEB' : 'none')};
  ${media.tablet`
    padding: 56px 0;
  `}
`;

export const Fill = styled.div`
  background: #ebebeb;
`;

export const Container = styled.div`
  text-align: center;
`;

export const IntroContainer = styled.div`
  ${media.tablet`
    position: relative;
    text-align: left;
  `}
`;

export const Intro = styled.div`
  margin: 0 0 48px;
  ${media.tablet`
    margin: 0;
    position: relative;
    height: 707px;
    display: flex;
    align-items: center;
  `}
`;

export const IntroBackground = styled.div`
  display: none;
  ${media.tablet`
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
  `}
`;

export const IntroBackgroundImageContainer = styled.div`
  position: relative;
  ${media.tablet`
    height: 100%;
    width: 75%;
    float: right;
    right: -15%;
  `}
`;

export const IntroInner = styled.div`
  ${media.tablet`
    max-width: 40%;
  `}
`;

export const IntroHeading = styled.h1`
  margin: 0 0 26px;
  font-size: 28px;
  line-height: 36px;
  ${media.tablet`
    margin-bottom: 16px;
    font-size: 52px;
    line-height: 71px;
  `}
`;

export const IntroDescription = styled(Text)`
  margin: 0 0 48px;
  ${media.tablet`
    margin-bottom: 56px;
  `}
`;

export const EcommerceTechLogoContainer = styled.div`
  display: inline-block;
  margin-bottom: 48px;
  ${media.tablet`
    margin: 0;
    text-align: left;
    position: absolute;
    top: 64px;
    left: 0;
  `}
`;

export const EcommerceTechLogo = styled.div`
  width: 129px;
  height: 36px;
  ${media.tablet`
    width: 161px;
    height: 45px;
  `}
`;

export const EcommerceTechLogoTitle = styled.p`
  font-size: 12px;
  line-height: 1;
  margin: 12px 0 0;
`;

export const BrandsList = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  ${media.tablet`
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  `}
`;

export const BrandLogo = styled.span`
  display: block;
  margin: 0 auto;
  max-width: 184px;
  height: 80px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.15);
  padding: 8px;
  ${media.tablet`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  `}
`;

export const CardItem = styled.div`
  margin: 16px;
`;

export const CardTitle = styled(Text)`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
`;

export const FeaturesList = styled.ul`
  ${media.tablet`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  `}
`;

export const FeaturesListItem = styled.li`
  padding: 0 8px;
  margin: 24px 0 48px;
`;

export const FeaturesListItemText = styled(Text)`
  font-size: 16px;
  margin: 0;
`;

export const KpiContainer = styled.div`
  ${media.tablet`
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  `}
`;

export const KpiStats = styled.div`
  ${media.tablet`
    text-align: left;
    width: 40%;
    padding-left: 24px;
  `}
`;

export const KpiImage = styled.div`
  ${media.tablet`
    width: 60%;
  `}
`;

export const KpiList = styled.ul`
  text-align: left;
  ${media.PC`
    font-size: 24px;
  `}
`;

const getIcon = (rotated: boolean) =>
  rotated
    ? '/images/home/checkmark-green-rotated.svg'
    : '/images/home/checkmark-green.svg';

export const KpiListItem = styled.li<{ rotateIcon: boolean }>`
  background-image: url(${({ rotateIcon }) => getIcon(rotateIcon)});
  background-position: left center;
  background-repeat: no-repeat;
  padding-left: 24px;
`;

export const AdvantagesText = styled(Text)`
  margin: 24px 0;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  ${media.tablet`
    margin: 40px auto;
    max-width: 1000px;
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const IntegrationTextContainer = styled.div`
  ${media.tablet`
    display: flex;
    justify-content: center;
    margin-bottom: 56px;
  `}
`;

export const IntegrationTextContainerItem = styled.div`
  ${media.tablet`
    flex: 1;
    & + & {
      border-left: 1px solid #aaa;
    }
  `}
`;

export const IntegrationTextTitle = styled.span`
  display: block;
  font-size: 18px;
`;

export const IntegrationTextGroup = styled.span`
  display: block;
  ${media.PC`
    display: inline-flex;
    align-items: center;
  `}
`;

export const IntegrationTextItem = styled.span`
  display: block;
`;
